/* ==========================================================================
   DialogManager class
   ========================================================================== */

import dialogPolyfill from 'dialog-polyfill'
import 'dialog-polyfill/dialog-polyfill.css'

export default class CookiesBannerManager {
  dialogSelector: string = '[data-ui-el="nfb-dialog"]'
  el: HTMLDialogElement | undefined
  closeBtn: HTMLButtonElement | undefined

  constructor () {
    this.close = this.close.bind(this)
  }

  init (show = true): void {
    this.el = document.querySelector(this.dialogSelector) as HTMLDialogElement
    this.closeBtn = this.el?.querySelector(`${this.dialogSelector} [data-ui-el="close-btn"]`) as HTMLButtonElement
    this.closeBtn?.addEventListener('click', this.close)
    if (this.el != null) {
      dialogPolyfill.registerDialog(this.el)
    }
    if (show) {
      this.show()
    }
  }

  show (): void {
    this.el?.classList.remove('hide')
  }

  close (): void {
    this.el?.remove()
  }

  destroy (): void {
    this.closeBtn?.removeEventListener('click', this.close)
  }
}
